import React from 'react';

export const LeftIcon = () => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      style={{ fill: "#102641" }}
      d="M22.5247 5.51972C23.1473 5.51972 23.7802 5.75643 24.26 6.21017C25.2093 7.13738 25.2093 8.6367 24.26 9.55404L15.5019 17.9975L24.2804 26.4608C25.2399 27.388 25.2399 28.8774 24.2804 29.8046C23.3209 30.7318 21.7795 30.7318 20.82 29.8046L11.0003 20.3353C10.3675 19.7237 10 18.8754 10 17.9877C10 17.1098 10.3573 16.2516 10.9901 15.6401L20.7894 6.19045C21.2692 5.72685 21.8918 5.5 22.5145 5.5" fill="#121212" />
  </svg>
);

export const ApprovalIconNoOutline = () => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" >
    <path style={{ fill: "#FFF" }} d="M18 3C9.72 3 3 9.72 3 18C3 26.28 9.72 33 18 33C26.28 33 33 26.28 33 18C33 9.72 26.28 3 18 3ZM26.54 11.61L17.45 26.26C17.12 26.8 16.55 27.12 15.95 27.12C15.41 27.12 14.91 26.87 14.56 26.43L8.97 19.4C8.52 18.84 8.58002 18.01 9.11002 17.52C9.62002 17.04 10.47 17.03 10.99 17.5L15.74 21.79L24.25 10.06C24.67 9.48001 25.55 9.32 26.15 9.72C26.77 10.14 26.95 10.97 26.56 11.61H26.54Z" fill="#121212" />
  </svg>
)
